import store from "../../index.js";
import SherlockAcConstant from "@/mixins/sherlock/const/sherlockAcConstant.js";
import sherlockPoint from "./sherlock-point.js";
import sherlockDocument from "./sherlock-document.js";
import sherlockHouse from "./sherlock-house.js";
import sherlockUser from "./sherlock-user.js";
import sherlockFreetrial from "./sherlock-freetrial.js";
import sherlockAuth from "./sherlock-auth.js";
import sherlockCorp from "./sherlock-corp.js";
import sherlockSubscription from "./sherlock-subscription.js";
import sherlockDelinquency from "./sherlock-delinquency.js";
import sherlockMultiSearch from "./sherlock-multi-search.js";
import sherlockLead from "./sherlock-lead.js";
import { callPostApi } from "@/utils/apiWrapper";

export const modules = {
  store,
};

export const state = {
  _isMobile: false,
  _isSherlock: false,
  _menu: JSON.parse(localStorage.getItem("sherlock_menu")) || {
    activeTab: "point",
    activeSubTab: "",
  },
};

export const mutations = {
  setIsMobile(state, isMobile) {
    state._isMobile = isMobile;
  },
  setIsSherlock(state, isSherlock) {
    state._isSherlock = isSherlock;
  },
  setMenu(state, menu) {
    state._menu = menu;
    localStorage.setItem("sherlock_menu", JSON.stringify(state._menu));
  },
};

export const actions = {
  async acSendSherlockDelinquencyNotiRequest({ commit }) {
    const res = await callPostApi({
      url: `${SherlockAcConstant.POST_SHERLOCK_DELINQUENCY_NOTI_REQUEST}`,
      params: {},
      commit,
    });
    return res;
  },
};

export const getters = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules: {
    pointStore: sherlockPoint,
    documentStore: sherlockDocument,
    houseStore: sherlockHouse,
    userStore: sherlockUser,
    freetrialStore: sherlockFreetrial,
    authStore: sherlockAuth,
    corpStore: sherlockCorp,
    subscriptionStore: sherlockSubscription,
    delinquencyStore: sherlockDelinquency,
    multiSearchStore: sherlockMultiSearch,
    leadStore: sherlockLead,
  },
};
